import React from 'react'
import { styled } from '@mui/material/styles'
import {
  TextField,
  Box, Grid
} from '@mui/material'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import koLocale from 'date-fns/locale/ko'

const DialogTextField = styled(TextField)({
  backgroundColor: '#fff',
})

const DateRangeForm = ({
  dataKey,
  form,
  handleChangeData
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={koLocale}>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item xs={4}>
          <DatePicker
            label="시작일"
            maxDate={form[dataKey][1]}
            value={form[dataKey][0]}
            inputFormat={'yyyy-MM-dd'}
            mask={'____-__-__'}
            onChange={(newValue) => handleChangeData(dataKey, [newValue, form[dataKey][1]])}
            renderInput={(params) => <DialogTextField {...params} size={'small'} />}
          />
        </Grid>
        <Grid item xs={0}>
          <Box sx={{ mx: 1 }}> ~ </Box>
        </Grid>
        <Grid item xs={4}>
          <DatePicker
            label="종료일"
            minDate={form[dataKey][0]}
            value={form[dataKey][1]}
            inputFormat={'yyyy-MM-dd'}
            mask={'____-__-__'}
            onChange={(newValue) => handleChangeData(dataKey, [form[dataKey][0], newValue])}
            renderInput={(params) => <DialogTextField {...params} size={'small'} />}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  )
}

export default DateRangeForm